import { render, staticRenderFns } from "./LaravelVueGoodTable.vue?vue&type=template&id=07bd675c&"
import script from "./LaravelVueGoodTable.vue?vue&type=script&lang=js&"
export * from "./LaravelVueGoodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports